export class View {
    id: number;
    viewType: string;
}
    
